import {typedQuery} from "../../typing.ts";
import api from "../../../api/index.ts";

export const esignatureTemplates = typedQuery(["vendorToolkit", "esignatureTemplates"], async () => {
  return await api.vendorToolkit.esignatureTemplates.list();
});
